module.exports = __webpack_public_path__ + "static/AFNC_logo-2547661e8fbb9788256d6169b623f2dd.png";